import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import AuthGate from "./components/AuthGate";
import ReaderAdmin from "./pages/rfid/ReaderAdmin";
import TagAdmin from "./pages/rfid/TagAdmin";
import ClassStudentAdmin from "./pages/rfid/ClassStudentAdmin";
import AssignmentAdmin from "./pages/rfid/AssignmentAdmin";
import RecordAdmin from "./pages/rfid/RecordAdmin";

const App = () => (
  <AuthGate>
    {({ auth, logout }) => (
      <Router>
        <Routes>
          <Route path="/*" element={<AdminLayout auth={auth} logout={logout} />}>
            <Route path="readers" element={<ReaderAdmin />} />
            <Route path="tags" element={<TagAdmin />} />
            <Route path="classes" element={<ClassStudentAdmin />} />
            <Route path="assignments" element={<AssignmentAdmin />} />
            <Route path="records" element={<RecordAdmin auth={auth} />} />
            <Route path="*" element={<Navigate to="/tags" replace />} />
          </Route>
        </Routes>
      </Router>
    )}
  </AuthGate>
);
export default App;
